import {
  createContext,
  ReactNode,
  useState,
  Dispatch,
  SetStateAction,
} from 'react'

import { UploadableType } from '../../graphql/mutations/upload'

type PostOrTale = Post | Tale

type EditorContext = {
  hasFocus: boolean
  entityId?: PostOrTale['id']
  entityType: UploadableType
  setHasFocus: Dispatch<SetStateAction<boolean>>
}

export const editorContext = createContext<EditorContext>({
  hasFocus: false,
  setHasFocus: () => {},
  entityId: undefined,
  entityType: 'Tale',
})

type EditorContextProviderProps = {
  children: ReactNode | undefined
  value: Pick<EditorContext, 'entityId' | 'entityType'>
}

export const EditorContextProvider = ({
  children,
  value,
}: EditorContextProviderProps) => {
  const [hasFocus, setHasFocus] = useState(false)

  return (
    <editorContext.Provider value={{ ...value, hasFocus, setHasFocus }}>
      {children}
    </editorContext.Provider>
  )
}
